// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStepper-Stepper_cls1__Nhox3","cls2":"VeloStepper-Stepper_cls2__pEC0I VeloStepper-Stepper_cls1__Nhox3","form":"VeloStepper-Stepper_form__Z90KZ"};